import * as v from "valibot";
import { overviewSearchParams } from "@/shared/model/overview-search-params";

export const searchParams = v.object({
  ...overviewSearchParams.entries,
  editClient: v.optional(v.boolean()),
  customSubscription: v.optional(v.boolean()),
  tab: v.optional(v.picklist(["company", "licence", "overrides"])),
});
